import en_GB from "./en_GB";

export default {
  en_GB
};